<section class="container-fluid temp-color">
  <div class="row">
    <div class="col-sm-2 padding-left">
      <security-navigation class="sticky-nav"> </security-navigation>
    </div>
    <div class="col-sm-10 padding-left">
      @if (successMessage?.message?.length > 0) {
        <div class="padding-sides">
          <nfrp-alert alertId="edit-core-success" type="success" [message]="successMessage" [page]="false"> </nfrp-alert>
        </div>
      }
      @if (errorMessage?.message?.length > 0) {
        <div class="padding-sides">
          <nfrp-alert alertId="edit-core-error" [message]="errorMessage" type="error" [page]="false"> </nfrp-alert>
        </div>
      }
      <ng-container>
        <form class="mt-10" [formGroup]="particActivateForm">
          <ul id="plan-params" summary="activate plan" class="ul-li-view-edit table stripes no-margin border-common">
            <li class="head">
              <div class="col-sm-12 padding-left">
                <b>Activate Participants</b>
              </div>
            </li>
            <li>
              <div class="col-sm-2 padding-left"><b>Plan:</b></div>
              <div class="col-sm-3">
                <select
                  formControlName="planNo"
                  name="planNo"
                  id="planId"
                  tabindex="5"
                  [ngClass]="{
                    'has-error': isControlInvalid('planNo')
                  }"
                  #selectedValue
                  (change)="changePlanNoEvent($event)"
                  >
                  <option [ngValue]="null">--- Select from list ---</option>
                  @for (plan of planMnyMgrDetails | orderBy: 'planDesc'; track plan; let i = $index) {
                    <option
                      [value]="plan.planId"
                      >
                      {{ plan.planDesc }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-sm-2">
                <input
                  type="button"
                  id="search-button"
                  class="button-primary button hover-right margin-right"
                  (click)="checkPlanSelect()"
                  value="Select"
                  />
                </div>
                <div class="col-sm-5"></div>
              </li>
              <div>
                @if (
                  (participantIkControl.planNo.touched || submitted) && participantIkControl.planNo.errors?.required
                  ) {
                  <nfrp-inline-error
                    errorId="planNo-valid-error"
                    [message]="getChooseErrorMessage('Plan')"
                    >
                  </nfrp-inline-error>
                }
              </div>
            </ul>
            @if (planFeeDetails || planRepresentativeDetails) {
              <ul
                id="core-plan-params"
                summary="ik plan"
                class="ul-li-view-edit table stripes margin-top-2 border-common"
                >
                <li class="head">
                  <div class="col-sm-12 padding-left">
                    <b>Participant Information</b>
                  </div>
                </li>
                <li>
                  <div class="col-sm-2 padding-left"><b>Fee Program:</b></div>
                  <div class="col-sm-10">
                    <select
                      formControlName="feeProgram"
                      name="feeProgram"
                      id="planPgm"
                      tabindex="5"
                  [ngClass]="{
                    'has-error': isControlInvalid('feeProgram')
                  }"
                      (change)="getSelectedfeePgm($event)"
                      >
                      <option [ngValue]="null">--- Select from list ---</option>
                      @for (feeProgram of planFeeDetails; track feeProgram; let i = $index) {
                        <option [value]="feeProgram.feeProgramId">
                          {{ feeProgram.feeProgramDesc }} &nbsp;[PPA ={{ feeProgram.ppaFeePct }},RIA={{
                          feeProgram.riaFeePct
                          }},MGR={{ feeProgram.mgrFeePct }},SOL={{ feeProgram.solicitorFeePct }},TOT={{
                          feeProgram.totMgmtFeePct
                          }}
                        </option>
                      }
                    </select>
                    <span>
                      @if (
                        (participantIkControl.feeProgram.touched || submitted) &&
                        participantIkControl.feeProgram.errors?.required
                        ) {
                        <nfrp-inline-error
                          errorId="feeProgram-valid-error"
                          [message]="getChooseErrorMessage('Fee Program')"
                          >
                          </nfrp-inline-error
                          >
                      }</span>
                    </div>
                  </li>
                  <li>
                    <div class="col-sm-2 padding-left"><b>Representative:</b></div>
                    <div class="col-sm-4">
                      <select
                        multiple
                        size="3"
                        name="representative"
                        class="rep-width"
                        (change)="getSelectedRep($event)"
                        formControlName="representative"
                        >
                        @for (rep of planRepresentativeDetails; track rep; let i = $index) {
                          <option [value]="rep">
                            {{ rep.repFirstName }}&nbsp;{{ rep.repLastName }}&nbsp;[{{ rep.repNumber }}] &nbsp;-&nbsp;{{
                            rep.solFirmName
                            }}&nbsp;[{{ rep.solicitorNbr }}]
                          </option>
                        }
                      </select>
                    </div>
                    <div class="col-sm-6">
                      <b>Global Contract Date:</b>&nbsp;<input type="text" (keyup)="onKeyUpContractDate($event)" />
                    </div>
                  </li>
                  <div>
                    @if (
                      (participantIkControl.representative.touched || submitted) &&
                      participantIkControl.representative.errors?.required
                      ) {
                      <nfrp-inline-error
                        errorId="representative-valid-error"
                        [message]="'Please select atleast one representative'"
                        >
                      </nfrp-inline-error>
                    }
                  </div>
                </ul>
              }
            </form>
            @if (dataSource) {
              <ul id="core-plan-params" summary="ik plan" class="ul-li-view-edit table stripes margin-top-2">
                <li class="head">
                  <div class="col-sm-3 padding-left">
                    <span class="margin-left-2" (click)="checkAll()"><a>[Select All]</a></span
                    >&nbsp;&nbsp;&nbsp;<span (click)="uncheckAll()"><a>[Unselect All]</a></span>
                  </div>
                  <div class="col-sm-4"></div>
                  <div class="col-sm-2">
                    <label (click)="resetParticIkForm()">[<a>Restore Default Values</a>]</label>
                  </div>
                  <div class="col-sm-1"></div>
                  <div class="col-sm-2">
                    <label class="float-right" (click)="clearDates()">[<a>Clear Dates</a>]</label>
                  </div>
                </li>
              </ul>
              <ul class="ul-li-view-edit">
                <ng-template #headerTemplate>
                  <div nfrpColumn [width]="10" widthType="%" [id]="'select-label'" defaultDirection="ASCENDING">
                    Select
                  </div>
                  <div nfrpColumn [width]="10" widthType="%" [id]="'ssn-label'">
                    SSN
                  </div>
                  <div nfrpColumn [width]="10" widthType="%" [id]="'last-name-label'">
                    Last Name
                  </div>
                  <div nfrpColumn [width]="10" widthType="%" [id]="'first-name-label'">
                    First Name
                  </div>
                  <div nfrpColumn [width]="20" widthType="%" [id]="'birth-date-label'">
                    Birth Date
                  </div>
                  <div nfrpColumn [width]="20" widthType="%" [id]="'hire-date-label'">
                    Hire Date
                  </div>
                  <div nfrpColumn [width]="20" widthType="%" [id]="'contract-date-label'">
                    Contract Date
                  </div>
                </ng-template>
                <ng-template #rowTemplate let-getIkParticipant="item" let-index="index">
                  <div>
                    <div [id]="'select-' + index">
                      <input
                        type="checkbox"
                        id="participant-{{ index }}"
                        [checked]="getIkParticipant.selected"
                        [(ngModel)]="getIkParticipant.selected"
                        (change)="updateCheckedOptions(getIkParticipant, $event)"
                        />
                      </div>
                      <div [id]="'ssn-' + index">
                        {{ getIkParticipant?.ssn | nfrpNormalizeValue: '-' }}
                      </div>
                      <div [id]="'last-name-' + index">
                        {{ getIkParticipant?.lastName | nfrpNormalizeValue: '-' }}
                      </div>
                      <div [id]="'first-name-' + index">
                        {{ getIkParticipant?.firstName | nfrpNormalizeValue: '-' }}
                      </div>
                      <div [id]="'birth-date-' + index">
                        {{ getIkParticipant?.birthDtInString | nfrpNormalizeValue: '-' }}
                      </div>
                      <div [id]="'hire-date-' + index">
                        {{ getIkParticipant?.hireDtInString | nfrpNormalizeValue: '-' }}
                      </div>
                      <div [id]="'contract-date-' + index">
                        <input
                          type="text"
                          id="participant-{{ index }}"
                          name="getIkParticipant?.contractDtInString"
                          [value]="getIkParticipant?.contractDtInString"
                          [(ngModel)]="getIkParticipant.contractDtInString"
                          />
                        </div>
                      </div>
                    </ng-template>
                    <nfrp-grid
                      [headerTemplate]="headerTemplate"
                      [rowTemplate]="rowTemplate"
                      [iterable]="data"
                      [width]="100"
                      rowIdPrefix="ik-details"
                    ></nfrp-grid>
                    <nfrp-grid-paginator
                      (paginate)="paginate($event)"
                      [numberOfItems]="numberOfItems"
                      [itemsPerPageOptions]="[5, 10, 20]"
                      [defaultItemsPerPage]="5"
                    ></nfrp-grid-paginator>
                  </ul>
                  <div class="row margin-top-1">
                    <div class="col-sm-3 no-padding">
                      <input
                        type="button"
                        class="button-primary button hover-right margin-right"
                        (click)="removeParticipants()"
                        value="Remove Participant(s)"
                        />
                      </div>
                      <div class="col-sm-2 no-padding"></div>
                      <div class="col-sm-3 no-padding">
                        <input
                          id="search-button"
                          class="button-primary button hover-right margin-right"
                          type="submit"
                          size="40"
                          (click)="activateParticipants()"
                          value="Activate Participant(s)"
                          />
                        </div>
                        <div class="col-sm-4"></div>
                      </div>
                    }
                    @if (loading) {
                      <nfrp-spinner></nfrp-spinner>
                    }
                  </ng-container>
                </div>
              </div>
            </section>
